import React, {Fragment, useState} from "react"
import moment from "moment"

// UI
import {Accordian} from "@uprise/accordian"
import {Row, Col} from "@uprise/grid"
import {Medium} from "@uprise/text"

import {retrieveSurvey} from "uprise-surveys/lib/surveys/index"
// Components
import {WHO5STRESSResult} from "../WHO5STRESS/WHO5STRESSResult"
import AccordianCustom from "../../AccordianCustom"
import Header from "../../Header"

export const WHO5STRESSResults = ({results, tasks, custom = false}) => {
	const result = results.map((result, index) => {
		const survey = retrieveSurvey(result?.surveyId)
		const taskId = result.taskId

		const currentTask = tasks[taskId]
		const title = currentTask?.title || taskId
		const format = custom ? "DD/MM/YYYY" : "MMMM Do YYYY, h:mm:ss a"
		const date = moment.unix(result.timestamp).format(format)

		let analysis

		try {
			if (result.answers.WHO5 && result.answers.WHO5.length === 6) {
				const bonus = result.bonus ? result.bonus : result.answers.WHO5[result.answers.length - 1]
				analysis = survey.analysis(result?.answers, bonus)
			} else {
				analysis = survey.analysis(result?.answers)
			}

			const surveyTasks = Object.keys(result?.answers)

			const header = custom ? (
				<Row>
					<Col className='col-6 col-lg-6 col-md-6 col-sm-12'>
						<div>{title}</div>
					</Col>
					<Col className='col-6 col-lg-6 col-md-6 col-sm-12'>
						<Medium className='m-r-5'>{"Summary " + date}</Medium>
					</Col>
				</Row>
			) : (
				`${title} - ${date}`
			)

			return {
				header: <Header timestamp={result.timestamp} title={title} custom={custom} />,
				content: (
					<WHO5STRESSResult
						key={index}
						surveyTasks={surveyTasks}
						analysis={analysis}
						survey={survey}
						custom={custom}
					/>
				)
			}
		} catch (error) {
			console.log(error)
			analysis = {}
		}
	})

	return <AccordianCustom result={result} custom={custom} />
}
